import {
  PurchaseRequisitionStateTypes,
  PurchaseRequisitionActionTypes,
} from "./PurchaseRequisition.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: PurchaseRequisitionStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const PurchaseRequisitionReducer = (
  state: PurchaseRequisitionStateTypes = INITIAL_STATE,
  action: any
): PurchaseRequisitionStateTypes => {
  switch (action.type) {
    case PurchaseRequisitionActionTypes.FETCH_ALL_PURCHASE_REQUISITION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case PurchaseRequisitionActionTypes.FETCH_ALL_PURCHASE_REQUISITION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PurchaseRequisitionActionTypes.FETCH_ALL_PURCHASE_REQUISITION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PurchaseRequisitionActionTypes.FETCH_ALL_PURCHASE_REQUISITION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case PurchaseRequisitionActionTypes.FETCH_ONE_PURCHASE_REQUISITION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case PurchaseRequisitionActionTypes.FETCH_ONE_PURCHASE_REQUISITION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PurchaseRequisitionActionTypes.FETCH_ONE_PURCHASE_REQUISITION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PurchaseRequisitionActionTypes.FETCH_ONE_PURCHASE_REQUISITION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default PurchaseRequisitionReducer;
